import { render, staticRenderFns } from "./DashboardSectionLabel.vue?vue&type=template&id=33f9a891&scoped=true&"
var script = {}
import style0 from "./DashboardSectionLabel.vue?vue&type=style&index=0&id=33f9a891&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9a891",
  null
  
)

export default component.exports